import { render, staticRenderFns } from "./CalculatorLoader.vue?vue&type=template&id=896a866e&scoped=true&"
import script from "./CalculatorLoader.vue?vue&type=script&lang=js&"
export * from "./CalculatorLoader.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorLoader.vue?vue&type=style&index=0&id=896a866e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896a866e",
  null
  
)

export default component.exports